// Type-count chips at top of Transactions page — clickable filters.
// Purpose: users see instantly "Income: 3 · Revenue: 5 · Expense: 200" so nothing feels missing.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const TYPES = ["income", "revenue", "expense", "recurring", "borrow", "lend", "savings"];
const fmt = (n) => Math.round(Number(n || 0)).toLocaleString();

export function TxStatsChips({ activeType, onPick }) {
  const { t } = useI18n();
  const [stats, setStats] = useState({ total_count: 0, by_type: {} });

  useEffect(() => {
    let alive = true;
    api.get("/transactions/stats").then((r) => { if (alive) setStats(r.data || { by_type: {} }); }).catch(() => {});
    const onChange = () => api.get("/transactions/stats").then((r) => setStats(r.data)).catch(() => {});
    window.addEventListener("malat:data-changed", onChange);
    return () => { alive = false; window.removeEventListener("malat:data-changed", onChange); };
  }, []);

  const has = (typ) => stats.by_type?.[typ]?.count > 0;
  const visible = TYPES.filter((k) => has(k) || k === activeType);
  if (visible.length === 0) return null;

  return (
    <div data-testid="tx-stats-chips" className="flex flex-wrap gap-1.5 px-1">
      <button data-testid="chip-all" onClick={() => onPick("")}
        className={`px-3 py-1.5 rounded-full text-[11px] font-bold whitespace-nowrap transition ${activeType === "" ? "bg-primary text-white shadow-inner" : "bg-card border border-border text-slate-600"}`}>
        {t("all") || "الكل"} · {stats.total_count}
      </button>
      {visible.map((typ) => {
        const s = stats.by_type?.[typ] || { count: 0, total: 0 };
        const on = activeType === typ;
        return (
          <button key={typ} data-testid={`chip-${typ}`} onClick={() => onPick(typ)}
            className={`px-3 py-1.5 rounded-full text-[11px] font-bold whitespace-nowrap transition ${on ? "bg-primary text-white shadow-inner" : "bg-card border border-border text-slate-600"}`}>
            {t(typ)} · {s.count} · {fmt(s.total)}
          </button>
        );
      })}
    </div>
  );
}
